module.exports = __webpack_public_path__ + "img/Tablet - 8.b5d8b9ae.png";